import { axiosInstance } from '@/http-common'

/**
 * Post Notification Settings
 */
export function postNotificationSettings(imei: string, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/api/v1/notification-settings/edit/${imei}`, data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}
